export const styles = {
  //admin title at top right corner
  adminTitle: "flex justify-end w-full text-sm font-bold text-blue-200",

  //user's initials, name and email
  userContainer:
    "flex flex-col items-center justify-center bg-blue-900 rounded-md",
  initials: "text-2xl font-semibold text-white uppercase",

  //navlink
  navlinkActive:
    "bg-white/20 flex px-2 py-4 space-x-4 rounded-md text-white hover:bg-white/10",
  navlinkInactive:
    "flex px-2 py-4 space-x-4 rounded-md text-white hover:bg-white/10",

  //User's name and email
  nameEmailContainer: "flex flex-col justify-end px-2 text-sm text-gray-100",

  //logout button
  logoutBtnContainer:
    "flex px-2 py-4 space-x-4 rounded-md text-white hover:bg-white/10 cursor-pointer",
};
